

<div class="example-container"  >
    

  <mat-sidenav-container class="example-sidenav-container" >
    <mat-sidenav
      #snav
      style="width: 300px"
      [mode]="isMobile ? 'over' : 'side'"
      [opened]="!isMobile"
      [fixedInViewport]="isMobile">
      <side-navbar [is-mobile]=isMobile></side-navbar>
    </mat-sidenav>

  <mat-sidenav-content>

    <mat-toolbar style="background: {{topNavigationBackgroundColor}}" >
      <span class="mobile-menu title" >{{globals.getLocalizedValueIfAny(title)}}</span>
      <button mat-icon-button (click)="snav.toggle()" class="mobile-menu "><mat-icon>menu</mat-icon></button>
      <top-navbar ></top-navbar>
    </mat-toolbar>

    <div class="bgimg-1" [ngStyle]="{ 'background-image': 'url(' + background + ')'}">
      <div class="caption">
        <span class="border" style="font-family: {{secondaryFont}}, 'system-ui', 'sans-serif'">{{globals.getLocalizedValue(title)}} {{this.globals.selectedCurriculumPeriod}}</span>
      </div>
    </div> 
    <div class="content">
      <router-outlet style="width: 100% !important;"></router-outlet>
    </div>
    <div class="bgimg-2" [ngStyle]="{ 'background-image': 'url(' + background + ')'}"></div>
  </mat-sidenav-content>
</mat-sidenav-container>

</div>


